<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Question -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("QUESTION") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row class="ma-0 d-flex justify-center">
          <v-col class="d-inline-flex pa-0">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              rows="1"
              v-model="formGeneral.name1"
              :error-messages="name1Errors"
              @input="$v.formGeneral.name1.$touch()"
              @blur="$v.formGeneral.name1.$touch()"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Illutration data-->
    <v-row>
      <v-col cols="4" class="col-lable">
        <label class="font-weight-bold">
          {{ $t("ILLUSTRATION_DATA") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-img
              max-height="280"
              height="200"
              max-width="270"
              v-if="formGeneral.image"
              :lazy-src="formGeneral.image.fileUrl"
              :src="formGeneral.image.fileUrl"
              aspect-ratio="1.7"
              contain
            ></v-img>
            <v-img
              max-height="280"
              height="200"
              max-width="270"
              v-else
              class="mb-2"
              lazy-src="@/assets/defaultImage.jpg"
              src="@/assets/defaultImage.jpg"
              aspect-ratio="1.7"
              contain
            />
            <div
              v-if="
                imageError && (!formGeneral.image || !formGeneral.image.fileUrl)
              "
            >
              <div
                class="v-messages theme--light error--text ml-3"
                role="alert"
              >
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    挿絵データを選択ください。
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex pa-0">
            <v-spacer />
            <base-upload type="image" v-model="formGeneral.image">
              <span slot="activator">
                <v-btn class="primary" height="40px">{{
                  $t("FILE_SELECT")
                }}</v-btn>
              </span>
            </base-upload>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Answer -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable"></v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            class="pl-2 py-0"
            cols="6"
            v-for="(item, index) in $v.formGeneral.answers.$each.$iter"
            :key="item.id"
          >
            <v-radio-group
              hide-details
              class="mt-5"
              v-model="formGeneral.isAnsewr"
              :mandatory="false"
            >
              <v-text-field
                class="ml-1"
                v-model="item.value.$model"
                :error-messages="answersErrors(item.value)"
                @input="item.value.$touch()"
                @blur="item.value.$touch()"
                :style="
                  index % 2 == 0 ? 'margin-right:2.4rem' : 'margin-left:2.2rem'
                "
                dense
                outlined
              >
                <template v-slot:prepend>
                  <v-radio :value="item.$model.id"></v-radio>
                </template>
                <template v-slot:label>
                  <h3>
                    {{ item.$model.name }}
                    <span class="red--text">*</span>
                  </h3>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormShortSentences",
  mixins: [validationMixin],
  props: ["parent"],
  store: ["formGeneral"],
  validations: {
    formGeneral: {
      name1: { required },
      answers: {
        required,
        $each: {
          value: {
            required,
            strongAnswers(answers) {
              return !this.format.test(answers); // checks for special char
            },
          },
        },
      },
      leadSentence: { required },
    },
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    name1Errors() {
      const errors = [];
      if (!this.$v.formGeneral.name1.$dirty) return errors;
      !this.$v.formGeneral.name1.required &&
        errors.push("問題文を入力してください。");
      return errors;
    },
  },
  mounted() {
    let update = this.$route.name.search("Update");
    if (update == -1) {
      this.formGeneral.leadSentence =
        "文や イラストを みて、問題に こたえてください。";
    }
  },
  data() {
    return {
      imageError: false,
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
    };
  },
  methods: {
    async getParams() {
      this.$v.$touch();
      const {
        image,
        leadSentence,
        name1,
        isAnsewr,
        answers,
      } = this.formGeneral;
      this.imageError = !image || !image.fileUrl ? true : false;
      var params = "";
      if (!this.$v.$anyError && !this.imageError) {
        params = {
          sub_key: this.$route.params[this.parent],
          parent: this.parent,
          name: [[name1]],
          answer1: answers[0].value,
          answer2: answers[1].value,
          answer3: answers[2].value,
          answer4: answers[3].value,
          lead_sentence: leadSentence,
          audio: "",
          script: "",
          image,
          verb: "",
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
            question2: {
              answers: [
                {
                  id: 1,
                  name: "回答1",
                  value: "",
                },
                {
                  id: 2,
                  name: "回答2",
                  value: "",
                },
                {
                  id: 3,
                  name: "回答3",
                  value: "",
                },
                {
                  id: 4,
                  name: "回答4",
                  value: "",
                },
              ],
              audio: null,
              isAnsewr: 1,
              script: "",
            },
          },
          list_answer: {
            sentence_answer: [],
            answer: [],
          },
        };
      }
      return params;
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) return "回答を入力してください。";
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
    },
  },
};
</script>
<style scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
</style>